export const ehsData = {
  banner: {
    image: "/images/ehs-banner.jpg",
    alt: "EHS",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "EHS", href: "/ehs" },
  ],
  title: "EHS",
  sections: {
    infrastructure: {
      title: "Infrastructure",
      anchor: "infra",
      items: [
        "Kurkumbh facility is a Zero liquid discharge unit.",
        "Compliant with state & local EHS regulations",
        "HAZOP studies of processes after development",
        "Emergency response measures to control and limit the impact of incidents",
      ],
    },
    policy: {
      title: "Policy",
      anchor: "policy",
      items: [
        "To ensure that all manufacturing activities are performed in the safest possible manner.",
        "To ensure that appropriate health and safety studies are performed during development.",
        "Provide comfortable and safe workplace for employees as well as our associates and third party personnel",
        "Enhance quality, environment, health and safety standards",
        "To contribute to community development by actively participating in community development programs as part of our corporate social responsibility.",
      ],
    },
  },
};